import { AppLayout } from 'user/components/AppLayout'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { Error500 } from 'shared/page/Error500'

import { SignUp } from '../pages/SignUp'
import { Success } from '../pages/Success'
import PrivateRoute from './components/PrivateRoute.js'

function Routes ({ isNewHeaderEnabled }) {
  return (
    <BrowserRouter basename="/cadastre-se">
      <Switch>
        <AppLayout isNewHeaderEnabled={isNewHeaderEnabled}>
          <PrivateRoute exact path="/" component={SignUp} />
          <Route exact path="/erro-interno" component={Error500} />
          <Route exact path="/sucesso" component={Success} />
        </AppLayout>
      </Switch>
    </BrowserRouter>
  )
}

export default Routes
